import React from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { setRequestOpen } from './ImageViewerActions'
import IconDocument from '@tecuity/sos-icons/react/document'

const OpenImageViewerButton = () => {
  const dispatch = useDispatch()

  const { envelopeId, imageViewerDln } = useSelector((state) => state.imageViewer, shallowEqual)

  if (envelopeId && imageViewerDln) {
    return (
      <div className="image-viewer-button-wrapper">
        <button title="open image viewer" className="image-viewer-button" onClick={() => dispatch(setRequestOpen(true))}>
          <IconDocument />
        </button>
      </div>
    )
  } else return null
}

export default OpenImageViewerButton
